import { create } from 'zustand'
import { subscribeWithSelector } from 'zustand/middleware'

// Ball textures/colors
const ballSkins = [
    { id: 'fire', name: 'FIRE', color: '#ef4444', emissive: '#dc2626', icon: '🔥' },
    { id: 'ice', name: 'ICE', color: '#22d3ee', emissive: '#0891b2', icon: '❄️' },
    { id: 'gold', name: 'GOLD', color: '#fbbf24', emissive: '#d97706', icon: '⭐' },
    { id: 'nature', name: 'NATURE', color: '#22c55e', emissive: '#16a34a', icon: '🌿' },
    { id: 'purple', name: 'COSMIC', color: '#a855f7', emissive: '#7c3aed', icon: '🔮' },
    { id: 'electric', name: 'ELECTRIC', color: '#3b82f6', emissive: '#2563eb', icon: '⚡' },
]

export default create(subscribeWithSelector((set, get) => ({
    // Ball skins
    ballSkins,
    selectedBall: ballSkins[1], // ICE ball default

    // Level configuration
    currentLevel: 1,
    maxLevel: 3,

    // Level settings
    levelSettings: {
        1: {
            name: 'EASY',
            blocks: 12,
            crystals: 1,
            dangers: 0,
            color: '#4ade80'
        },
        2: {
            name: 'HARD',
            blocks: 25,
            crystals: 3,
            dangers: 3,
            color: '#fbbf24'
        },
        3: {
            name: 'IMPOSSIBLE',
            blocks: 50,
            crystals: 7,
            dangers: 17,
            color: '#ef4444'
        }
    },

    blocksCount: 12,
    blocksSeed: 0,

    // Collectibles
    crystals: 0,
    totalCrystals: 1,

    // Time tracking
    startTime: 0,
    endTime: 0,

    // Game phases: 'menu' | 'ready' | 'playing' | 'ended' | 'failed'
    phase: 'menu',

    // Best times per level
    bestTimes: {
        1: null,
        2: null,
        3: null
    },

    // Actions
    selectBall: (ball) => {
        set({ selectedBall: ball })
    },

    selectLevel: (level) => {
        const settings = get().levelSettings[level]
        set({
            currentLevel: level,
            blocksCount: settings.blocks,
            totalCrystals: settings.crystals,
            blocksSeed: Math.random(),
            crystals: 0,
            phase: 'ready'
        })
    },

    backToMenu: () => {
        set({
            phase: 'menu',
            crystals: 0
        })
    },

    start: () => {
        set((state) => {
            if (state.phase === 'ready') {
                return { phase: 'playing', startTime: Date.now() }
            }
            return {}
        })
    },

    restart: () => {
        set((state) => {
            return {
                phase: 'ready',
                blocksSeed: Math.random(),
                crystals: 0,
                startTime: 0,
                endTime: 0
            }
        })
    },

    end: () => {
        set((state) => {
            if (state.phase === 'playing') {
                const endTime = Date.now()
                const time = (endTime - state.startTime) / 1000
                const currentBest = state.bestTimes[state.currentLevel]
                const newBestTimes = { ...state.bestTimes }

                if (currentBest === null || time < currentBest) {
                    newBestTimes[state.currentLevel] = time
                }

                return {
                    phase: 'ended',
                    endTime: endTime,
                    bestTimes: newBestTimes
                }
            }
            return {}
        })
    },

    fail: () => {
        set((state) => {
            if (state.phase === 'playing') {
                return {
                    phase: 'failed',
                    endTime: Date.now()
                }
            }
            return {}
        })
    },

    collectCrystal: () => {
        set((state) => ({
            crystals: state.crystals + 1
        }))
    }
})))
